<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong v-if="Subscriber.subscriber_id==-1">Add Subscriber</strong>
          <strong v-if="Subscriber.subscriber_id>0">Edit Subscriber</strong>
        </div>
        <b-row style="vertical-align: middle;padding-bottom:5px;">
          <b-col md="5" class="d-inline-flex">
            <button class="btn btn-warning" @click="$router.go(-1)">
              <i title="Back" class="fa fa-arrow-left fa-lg text-white"></i> <strong class="text-white">Return to Users</strong>
            </button>
            <button class="btn btn-info ml-1" @click="saveSubscriber">
              <i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong>
            </button>

          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-row class="my-1">
              <b-col md="4">
                <label for="name">Subscriber Name</label>
              </b-col>
              <b-col md="8">
                <b-form-input type="text" v-validate="{required: true,min: 0, max: 20, regex: /^[\w\s']+$/ }" v-model="Subscriber.fullname" name="Name"></b-form-input>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col md="4">
                <label>Email</label>
              </b-col>
              <b-col md="8">
                <b-form-input type="email" v-validate="{required: true,email: true, min: 1, max: 40}" v-model="Subscriber.email" name="email"></b-form-input>
              </b-col>
            </b-row>

            <b-row class="my-1 align-items-center">
              <b-col md="4">
                <label>Main contact</label>
              </b-col>
              <b-col md="8">
                <c-switch  v-model="IsMainContact" type="text" variant="primary" on="Yes" off="No" :pill="true" />
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col md="12">
                <b-form-group label="Frequency">
                  <b-form-checkbox-group
                        v-model="selectedFrequency"
                        :options="Frequencies"
                        switches>
                  </b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4">
            <b-row class="my-1">
              <b-list-group style="min-width:100%">
                <b-list-group-item class="py-2" variant="danger" v-for="err in validateErrors.items" :key="err.id"> {{ err.msg }} </b-list-group-item>
              </b-list-group>
            </b-row>
          </b-col>
        </b-row>

      </b-card>
    </div>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import { setTimeout } from 'timers'
import VeeValidate from 'vee-validate'
import cSwitch from '../components/Switch'

export default {
  components: {
    loading,
    cSwitch
  },
  created () {
    var self = this
    this.getFrequencies()
    this.initForm()
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      IsMainContact: false,
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      Subscriber: {
        subscriber_id: -1
      },
      selectedFrequency: [],
      Frequencies: [ ]
    }
  },
  methods: {
    initForm () {
      if (this.$route.params.Subscriber_Id && parseInt(this.$route.params.Subscriber_Id) !== -1) {
        axios.get('/api/mprove/settingsGetSubscriberByID?' + this.$route.params.Subscriber_Id)
          .then(response => {
            this.boolLoading = false
            if (response.data === undefined || response.data === null) {
              this.Subscriber = {}
            } else {
              this.Subscriber = response.data.Subscriber[0]
              this.Subscriber.subscriber_id = response.data.Subscriber[0].subscriber_id
              this.IsMainContact = response.data.IsMainContact
              this.selectedFrequency = response.data.Frequencies
            }
          })
          .catch(error => {
            if (error.response.status == 403) { this.$router.push('/login') }

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
          })
      } else {
        setTimeout(function () {
          self.user = {}
          self.boolLoading = false
        }, 500)
      }
    },
    saveSubscriber (p) {
      var self = this

      if (self.Subscriber.subscriber_id > 0) {
        self.editSubscriber(p)
      } else {
        self.addSubscriber(p)
      }
    },
    addSubscriber (p) {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          self.$dialog.confirm('Are you sure you would like to save changes?')
            .then(function () {
              var obj = {
                FullName: self.Subscriber.fullname,
                Email: self.Subscriber.email,
                Dealership_Id: self.Subscriber.dealership_id,
                IsMainContact: self.IsMainContact,
                Frequencies: self.selectedFrequency
              }
              axios.post('/api/mprove/AddSettingsSubscriber', obj)
                .then(response => {
                  self.errMsg = 'Your changes has been saved'
                  self.dismissibleType = 'success'
                  self.showDismissibleAlert = true
                  self.boolLoading = false
                })
                .catch(error => {
                  if (error.response.status == 403) {
                    self.$router.push('/login')
                  }

                  self.boolLoading = false

                  self.errMsg = 'There was an error saving your changes : '
                  if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
                    self.errMsg = self.errMsg + error.response.statusText
                  } else {
                    self.errMsg = self.errMsg + error
                  }

                  self.showDismissibleAlert = true
                })
            })
            .catch(function () {
              console.log('Change canceled')
            })
        } else {
          // alert('Please correct errors first');

          self.errMsg = 'Please correct errors first'
          self.dismissibleType = 'danger'
          self.showDismissibleAlert = true

          setTimeout(function () {
            self.showDismissibleAlert = false
            self.errMsg = ''
          }, 8000)
        }
      })
    },
    editSubscriber (p) {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          self.$dialog.confirm('Are you sure you would like to save changes? Update')
            .then(function () {
              var obj = {
                Subscriber_Id: self.Subscriber.subscriber_id,
                FullName: self.Subscriber.fullname,
                Email: self.Subscriber.email,
                Dealership_Id: self.Subscriber.dealership_id,
                IsMainContact: self.IsMainContact,
                Frequencies: self.selectedFrequency

              }

              axios.post('/api/mprove/editSettings', obj)
                .then(response => {
                  self.errMsg = 'Your changes has been saved'
                  self.dismissibleType = 'success'
                  self.showDismissibleAlert = true
                  self.boolLoading = false
                })
                .catch(error => {
                  if (error.response.status == 403) {
                    self.$router.push('/login')
                  }

                  self.boolLoading = false

                  self.errMsg = 'There was an error saving your changes : '
                  if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
                    self.errMsg = self.errMsg + error.response.statusText
                  } else {
                    self.errMsg = self.errMsg + error
                  }

                  self.showDismissibleAlert = true
                })
            })
            .catch(function () {
              // do nothing
            })
        } else {
          // alert('Please correct errors first');

          self.errMsg = 'Please correct errors first'
          self.dismissibleType = 'danger'
          self.showDismissibleAlert = true

          setTimeout(function () {
            self.showDismissibleAlert = false
            self.errMsg = ''
          }, 8000)
        }
      })
    },

    getFrequencies () {
      axios.get('/api/mprove/settingsGetFrequencies')
        .then(response => {
          this.boolLoading = false
          this.Frequencies = response.data
          this.lastRefreshed = moment()
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    }

  },

  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>

<style>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/mProveSettingsAdd.vue